/* eslint-disable react-hooks/rules-of-hooks */
import {
  all,
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';
import {Buffer} from 'buffer';
import { removeAuthToken, setAuthToken } from '../../lib/services/ApiInstance';
import { login, myNumber, resellerLogin,} from '../../lib/services/Apis';
import Data from '../../utils/SetGetData';
import { Navigate } from 'react-router-dom';
import {
  LOGIN,
  MYNUMBER,
  RESELLERLOGIN,
  saveUser
} from '../actions/user';


export function* asyncLogin({ payload }) {
  const { values, failure, success } = payload;
  try {
    const { data } = (yield call(login, values));
    success(data)
     const userInfo = {
          'admin':data.admin,
          'extension':data.extension,
          'extension_id':data.extension_id,
          'firstname':data.firstname,
          'lastname':data.lastname,
          'pin': data.pin,
          'tenant_id':data.tenant_id,
          'tenant_web_name' : data.tenant_web_name
       }
                  yield put(saveUser(userInfo));
       
  } catch (err) {
    failure(err);
  }
}
export function* asyncresellerLogin({ payload }) {
  const { values, failure, success } = payload;
  try {
    const { data } = (yield call(resellerLogin, values));
    success(data)
    //  const userInfo = {
    //       'admin':data.admin,
    //       'extension':data.extension,
    //       'extension_id':data.extension_id,
    //       'firstname':data.firstname,
    //       'lastname':data.lastname,
    //       'pin': data.pin,
    //       'tenant_id':data.tenant_id,
    //       'tenant_web_name' : data.tenant_web_name
    //    }
    //               yield put(saveUser(userInfo));
       
  } catch (err) {
    failure(err);
  }
}
export function* asyncMyNumber({ payload }) {
  const { tenant_id, failure, success } = payload;
  try {
    const { data } = (yield call(myNumber, tenant_id));
    success(data)
      
       
  } catch (err) {
    failure(err);
  }
}


export default function* () {
  yield all([takeLatest(LOGIN, asyncLogin)]);
  yield all([takeLatest(MYNUMBER, asyncMyNumber)]);
  yield all([takeLatest(RESELLERLOGIN, asyncresellerLogin)]);


}
